import React, { useEffect } from "react";
import { connect } from "react-redux";
import { login3 } from "../../actions";
import DotLoader from "../Loaders/DotLoader";
import styled from "styled-components";
import qs from "qs";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const LoginEpsilonConsume = (props) => {
  const { login3 } = props;

  const queryParams = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    login3({ ...queryParams });
  }, [login3]);

  return (
    <Wrapper>
      <DotLoader />
    </Wrapper>
  );
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    login3: ({ orgId, Secret, IV }) => {
      dispatch(
        login3({
          orgId,
          strategy: "epsilon",
          props: { strategy: "epsilon", Secret, IV },
        })
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginEpsilonConsume);
